import slotShouldForwardProp from './slotShouldForwardProp';
const rootShouldForwardProp = prop => slotShouldForwardProp(prop) && prop !== 'classes';
export default rootShouldForwardProp;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/rootShouldForwardProp.js
// module id = 778
// module chunks = 22